module.exports = __webpack_public_path__ + "static/media/fc-logo.97b01fd8.png";